import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect, useLocation } from 'react-router-dom';
import { ArcRoutes } from '../../../pages/arc/constants/routes';
import { TcsmStates } from '../../../root/tcsm-model';
import { useBasePath } from '../../hooks/useBasePath';

export const withInstitutionSelect = () => (WrappedComponent: React.ComponentType<any>) => {
	return (props: React.PropsWithChildren<any>) => {
		const location = useLocation();
		const institutionSelect = useBasePath(`${ArcRoutes.ArcRoot}${ArcRoutes.InstitutionRoot}${ArcRoutes.InstitutionSearch}`);
		const institutionClientNumber = useSelector<TcsmStates, string>(state => state.institutionState?.institutionClientNumber);
		if (!institutionClientNumber) {
			return (
				<Redirect to=
					{
						{
							pathname: institutionSelect,
							state: {
								actionLink: location.pathname,
							},
						}
					}
				/>);
		}
		return (<WrappedComponent {...props}>
			{props.children}
		</WrappedComponent>);

	};
};
